import { render, staticRenderFns } from "./EvaluationTrainingColdFilePage.vue?vue&type=template&id=6483ca36&"
import script from "./EvaluationTrainingColdFilePage.vue?vue&type=script&lang=js&"
export * from "./EvaluationTrainingColdFilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports